


const initProductSingleLoveForHue = () => {
    const heroSection = document.querySelector('.product-hero.love-for-hue');
    const variantIdSelectorList = heroSection.querySelectorAll('input[name="visible-selector"]');
    const imageTrigger = heroSection.querySelectorAll('[data-image-trigger]');

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const selectedVariantId = params['variant'] || '';

    if (variantIdSelectorList) {
        variantIdSelectorList.forEach(variantIdSelector => {

        variantIdSelector.addEventListener('change', e => {
            if (variantIdSelector.checked = true){
                let visibleSelectorValue = variantIdSelector.value;
                let productSelectorId = variantIdSelector.dataset.productSelectorId
                let hiddenSelector = document.getElementById(productSelectorId);

                hiddenSelector.value=visibleSelectorValue;
                hiddenSelector.dispatchEvent(new Event('change'));

                // work around till issue with flickity is discovered.
                setTimeout(function() {
                    const variantTitle = e.target.dataset.variantTitle;
                    const triggers = Array.from(imageTrigger).filter(image => {
                        const triggerImg = image.querySelector('img');
                        if (variantTitle == triggerImg.alt) {
                            return image;
                        }
                    })

                    if (window.matchMedia("(min-width: 900px").matches) {
                        triggers[0].click();
                    } else {
                        const sliders = document.querySelectorAll('[data-flickity-slider]');
                        sliders.forEach(slider => {
                            // Retrigger flickity again
                            let fSlider = new Flickity(slider);
                            fSlider.select(triggers[0].dataset.imageTrigger - 1)
                        })
                    }
                }, 250)
            }})
    })};
};
initProductSingleLoveForHue()